import { Injectable, inject } from '@angular/core';
import { IIssue } from 'shared';

import { IssueService } from '../issue.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface IssueCreatedSocketEvent {
    eventDtoType: 'IssueCreated';
    issue: IIssue;
}

@Injectable({ providedIn: 'root' })
export class IssueCreatedSocketEventHandler extends BaseSocketEventHandler<IssueCreatedSocketEvent> {
    private issueService = inject(IssueService);

    eventDtoType(): string {
        return 'IssueCreated';
    }

    handleEvent = async (event: IssueCreatedSocketEvent) => {
        this.issueService.localUpdate(event.issue);
    };
}
